export const COOKIE_REDIRECT_PATH = 'redirect-target-path'

export const COOKIE_SHOW_SPLASH = 'show-splash-screen'

export const COOKIE_FAVOURITES = 'cookie-favourites'
